export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto">
          <div className="max-w-[800px] mx-auto text-center">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              关于樱花TV
            </h2>
            <div className="mt-8 p-6 md:p-8 bg-background-50 rounded-lg border border-background-200/60">
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                樱花TV是一个致力于为全球华语观众提供免费高清影视内容的在线平台。我们聚合了来自日本、韩国、欧美及国产的优质影视资源，涵盖日剧美剧、国产电视剧、华语电影和欧美大片等多种类型。平台以&quot;零成本享受海量影视&quot;为核心理念，无需注册、无需付费、无需下载客户端，打开浏览器即可畅享全高清流畅播放体验。我们每日更新超过30部影视内容，确保观众总能看到最新、最热的作品。
              </p>
              <div className="mt-6 flex flex-wrap items-center justify-center gap-8">
                <div className="text-center">
                  <span className="block text-2xl font-heading font-bold text-primary-500">10万+</span>
                  <span className="text-xs text-foreground-600">影视资源库</span>
                </div>
                <div className="text-center">
                  <span className="block text-2xl font-heading font-bold text-primary-500">5000万+</span>
                  <span className="text-xs text-foreground-600">月活跃观众</span>
                </div>
                <div className="text-center">
                  <span className="block text-2xl font-heading font-bold text-primary-500">3年</span>
                  <span className="text-xs text-foreground-600">稳定运营</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}